<app-page-layout>
  <app-page-bar>
    <app-bar-back-button *ngIf="testId"
                         [link]="['/tests/', testId]"
                         [tooltip]="'Тест'"></app-bar-back-button>
    <app-bar-title>Результаты тестирования</app-bar-title>
    <button mat-icon-button *ngIf="canExport"
            matTooltip="Экспорт"
            (click)="openTestResultsExportDialog()">
      <mat-icon>file_download</mat-icon>
    </button>
  </app-page-bar>
  <app-page-content>
    <app-test-result-filters
      [filters]="filters"
      (apply)="onFiltersChange($event)"></app-test-result-filters>
    <mat-divider></mat-divider>
    <app-test-results-table *ngIf="testId"
                            [testId]="testId"
                            [displayedColumns]="displayedColumns"
                            [sort]="sort"
                            [dataSource]="dataSource"
                            [pageSizeOptions]="pageSizeOptions"
                            [pageSize]="pageSize"
                            [pageNumber]="pageNumber"></app-test-results-table>
  </app-page-content>
</app-page-layout>
